import { Controller } from 'stimulus';

const ZOOM_SCALE = 2.5;

export default class extends Controller {
  static targets = ['viewport', 'image', 'thumbnail'];

  select({ params, currentTarget }) {
    this.imageTarget.src = params.preview;
    this.imageTarget.dataset.zoom = params.zoom;

    this.thumbnailTargets.forEach((thumbnail) => {
      thumbnail.ariaPressed = thumbnail === currentTarget;
    });

    this.resetZoom();
  }

  zoom(event) {
    const { left, top, width, height } = this.viewportTarget.getBoundingClientRect();
    const x = ((event.clientX - left) / width) * 100;
    const y = ((event.clientY - top) / height) * 100;

    this.viewportTarget.style.backgroundImage = `url("${this.imageTarget.dataset.zoom}")`;
    this.viewportTarget.style.backgroundSize = `${ZOOM_SCALE * 100}%`;
    this.viewportTarget.style.backgroundPosition = `${x}% ${y}%`;
    this.imageTarget.style.opacity = 0;
  }

  resetZoom() {
    this.viewportTarget.style.backgroundImage = '';
    this.imageTarget.style.opacity = '';
  }
}
